var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start-date",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#9e9e9e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_calendar-clock",
    "data-name": "Path / calendar-clock",
    d: "M15,13h1.5v2.82l2.44,1.41-.75,1.3L15,16.69V13m4-5H5V19H9.67A7.009,7.009,0,0,1,19,9.67V8M5,21a2,2,0,0,1-2-2V5A1.993,1.993,0,0,1,5,3H6V1H8V3h8V1h2V3h1a2,2,0,0,1,2,2v6.1A7,7,0,0,1,11.1,21H5m11-9.85A4.85,4.85,0,1,0,20.85,16,4.85,4.85,0,0,0,16,11.15Z",
    transform: "translate(-1)",
    fill: "#9e9e9e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartDate);
export default __webpack_public_path__ + "static/media/start-date.40d13f73ed09ceaebae862294fc15057.svg";
export { ForwardRef as ReactComponent };